import { TextArea } from 'semantic-ui-react';
import styled from 'styled-components';

import { breakpoint } from './theme';

const StyledTextAreaWithIcon = styled(TextArea)<{ resize?: string }>`
  &&& {
    color: ${({ theme }) => theme.palette.black.primary};
    border-color: ${({ theme }) => theme.palette.gray.gallery};
    box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    min-height: 10rem;
    height: 13rem;
    padding: 1rem 2rem 1rem 4.5rem;
    margin-bottom: 0.5rem;
    resize: ${({ resize }) => resize || 'vertical'};

    &:focus {
      opacity: 1;
    }

    &::placeholder {
      color: ${({ theme }) => theme.palette.gray.dustyGray};
      opacity: 1;
    }

    ${breakpoint.up.md`
      font-size: 1.8rem;
      padding-left: 5.2rem;
    `};
  }
`;

export { StyledTextAreaWithIcon as TextAreaWithIcon };
